import React from 'react';
import { TableCellTitle } from 'src/components';
import { getTableRowColor } from '../../services';
import { MandatesListType } from 'src/pages/Mandates/models';

interface Props {
  type: MandatesListType;
  children: React.ReactNode;
}

const TableTitleCell = ({ type, children }: Props) => {
  return (
    <TableCellTitle color={getTableRowColor(type)}>{children}</TableCellTitle>
  );
};

export default TableTitleCell;
